import "./styles.css";
import React, { useMemo } from "react";
import { FaUserAlt, FaMoneyBill, FaExclamationCircle, FaTruck, FaClock } from "react-icons/fa";
import { TbDeviceIpadExclamation } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { format, toZonedTime } from "date-fns-tz";
import { addHours } from "date-fns";
import Swal from "sweetalert2";
import api from "../../Services/api"; // importar sua instância axios

const ListaOcorrenciaAvaliacao = ({ lista = [], maxHeight, onAtualizarLista }) => {

  const navigate = useNavigate();

  const formatarDataHora = (datahora) => {
    if (!datahora) return "-";
    const timeZone = "America/Sao_Paulo";
    const dataZoned = toZonedTime(datahora, timeZone);
    const dataSomada = addHours(dataZoned, 0);
    return format(dataSomada, "dd/MM/yyyy HH:mm:ss");
  };

  const sortedLista = useMemo(() => {
    return [...lista].sort((a, b) => {
      const dataA = a.datahora ? new Date(a.datahora).getTime() : 0;
      const dataB = b.datahora ? new Date(b.datahora).getTime() : 0;
      return dataB - dataA;
    });
  }, [lista]);

  const handleExibir = (IDvisita, IDusuario) => {
    navigate(`/Visita/${IDusuario}/${IDvisita}`);
  };

  const handleEnviar = async (item) => {
    const confirm = await Swal.fire({
      title: "Confirmar envio?",
      text: `Deseja realmente enviar como OK a ocorrência da visita nº ${item.IDvisita}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, enviar",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    let dados = JSON.parse(localStorage.getItem('usuarioLogado'));

    try {
      const payload = {
        IDvisita: item.IDvisita,
        situacao: "1",
        observacao: "Avaliado - " + new Date().toLocaleString("pt-BR") + ' - ' + dados.pessoa.nome,
      };

      const response = await api.post("/ocorrencia/avaliacao", payload);

      if (response.status === 201) {
        Swal.fire({
          title: "Sucesso!",
          text: "Ocorrência Avaliada com sucesso.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          if (onAtualizarLista) onAtualizarLista(); // 🔹 recarrega a lista
        });
      } else {
        Swal.fire({
          title: "Atenção",
          text: "Ocorreu um problema ao enviar a avaliação da ocorrência.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Erro",
        text: "Não foi possível enviar a avaliação da ocorrência.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div
      className="card_oco-container"
      style={{ maxHeight: maxHeight || "85vh", overflowY: "auto", padding: "10px" }}
    >
      {sortedLista.map((item) => (
        <div
          key={item.IDvisita}
          className="card_oco"
          style={{ backgroundColor: "#f28b8b", marginBottom: "15px" }}
          onClick={() => handleExibir(item.IDvisita, item.IDusuario)}
        >
          <div className="card_oco-content">
            <h5 style={{ width: "100%", textAlign: "start", paddingLeft: "5%" }}>
              <FaUserAlt style={{ marginRight: "8px" }} />
              {item.IDusuario} - {item.nome} - {formatarDataHora(item.datahora)}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Carga nº: {item.IDlote} | Visita nº: {item.IDvisita} <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cliente: {item.IDcliente} - {item.cliente}
            </h5>

            <div className="row">
              <div
                className="col-sm-6"
                style={{ paddingLeft: "8%", textAlign: "start", fontSize: "0.9em" }}
              >
                <p>
                  <FaMoneyBill style={{ marginRight: "6px" }} />
                  Valor: R$ {item.valor} | Qtde: {item.quantidade}
                </p>
                <p>
                  <FaMoneyBill style={{ marginRight: "6px" }} />
                  NF: {item.notaFiscal} | Pag: {item.planopag}
                </p>
                <p>
                  <FaTruck style={{ marginRight: "6px" }} />
                  Veículo: {item.modelo} ({item.placa})
                </p>
                <p>
                  <FaClock style={{ marginRight: "6px" }} />
                  Data: {formatarDataHora(item.datahora)}
                </p>
                <p>
                  <TbDeviceIpadExclamation style={{ marginRight: "6px" }} />
                  Obs: {item.observacao || "-"}
                </p>
              </div>

              <div className="col-sm-6" style={{ fontSize: "0.85em" }}>
                {item.registro?.map((reg, idx) => (
                  <div
                    key={idx}
                    style={{
                      marginBottom: "10px",
                      padding: "8px",
                      background: "#fff2",
                      borderRadius: "8px",
                    }}
                  >
                    <p>
                      <FaExclamationCircle style={{ marginRight: "6px", color: "red" }} />
                      Tipo: {reg.TipoOcorrencia}
                    </p>
                    <p>Obs: {reg.Observacao}</p>

                    {reg.Produtos?.length > 0 && (
                      <div style={{ marginTop: "5px" }}>
                        <b>Produtos:</b>
                        <ul style={{ paddingLeft: "18px", marginTop: "6px" }}>
                          {reg.Produtos.map((prod) => (
                            <li
                              key={prod.IDproduto}
                              style={{
                                marginBottom: "6px",
                                lineHeight: "1.4em",
                                background: "#fff3",
                                padding: "6px 8px",
                                borderRadius: "6px",
                              }}
                            >
                              <div>
                                <b>{prod.descricao}</b>
                              </div>
                              <div style={{ fontSize: "0.85em", color: "#333" }}>
                                ID: {prod.IDproduto} | Qtde ocorr.: {prod.quantidadeNaOcorrencia}
                              </div>
                              <div style={{ fontSize: "0.85em", color: "#333" }}>
                                Qtde: {prod.qtde} | Preço unit.: R$ {prod.precouni} | Total: R$ {prod.precototal}
                              </div>
                              {prod.obs && (
                                <div style={{ fontSize: "0.8em", color: "#555", marginTop: "2px" }}>
                                  Obs: {prod.obs}
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* 🔹 Botões de ação */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px" }}>
              <button
                className="btn btn-success btn-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleEnviar(item);
                }}
              >
                OK - Avaliado
              </button>

            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaOcorrenciaAvaliacao;
